<template>
  <form @submit.prevent="signIn">
    <StatusInformation :status="status">
      <h1 class="font-poppins text-3xl sm:text-4.5xl font-bold text-brand-darkGray">Login to Your Account</h1>
      <p class="text-brand-gray font-sans mt-4 mb-5">Please sign in to your account. Usernames and Passwords are case sensitive.</p>
    </StatusInformation>
    <AppNotifications />
    <TextInput
      id="username"
      v-model.trim="$v.form.username.$model"
      label="Username"
      name="username"
      placeholder="Username"
      autocomplete="username"
      autofocus
      class="mb-6"
      :isValid="isValid($v.form.username)"
      :errorMessage="validationMessage($v.form.username)"
    />
    <TextInput
      id="password"
      v-model.trim="$v.form.password.$model"
      label="Password"
      name="password"
      type="password"
      placeholder="Password"
      autocomplete="current-password"
      :togglePassword="true"
      class="mb-6"
      :isValid="isValid($v.form.password)"
      :errorMessage="validationMessage($v.form.password)"
    />
    <div class="flex flex-col sm:flex-row justify-between items-center">
      <button type="submit" class="button w-full sm:w-64">Sign In</button>
      <router-link to="password-reset" class="font-poppins self-start sm:self-auto mt-6 sm:mt-0 text-lg text-brand-secondary font-normal hover:underline" tabindex="10">Forgot Password?</router-link>
    </div>
  </form>
</template>

<script>
// import * as Sentry from '@sentry/vue'
// import { notificationHandler } from '~/utilities/helpers'
import validationMixin from '@/mixins/validation-mixin';
import { required } from 'vuelidate/lib/validators';
import StatusInformation from '@/components/StatusInformation.vue';
import { maybeLoadReCaptchaScript, shouldUseCaptcha } from '@/services/google-recaptcha';
import TextInput from '@/components/TextInput.vue';
import AppNotifications from '@/components/AppNotifications.vue';

export default {
  name: 'login',
  title: 'Login',
  components: { StatusInformation, TextInput, AppNotifications },
  mixins: [validationMixin],

  data () {
    return {
      status: this.$route.query.status,
      form: {
        username: '',
        password: '',
        redirectUrl: this.$route.query.redirectUrl
      }
    }
  },

  validations () {
    return {
      form: {
        username: {
          required
        },
        password: {
          required
        },
        redirectUrl: {}
      }
    }
  },

  methods: {
    async signIn () {
      this.$v.$touch();
      if(this.$v.$invalid)
        return;

      this.$store.commit('setLoading', true);
      this.$store.dispatch('login', this.$data.form).then(() => {
        let user = this.$store.getters.user
        this.$mixpanel.identify(user.email)

        this.$router.push('verify');
      })
      .catch((e) => {
        this.$error(e.message);
        this.form.password = '';
      }).finally(() => {
        this.$store.commit('setLoading', false);
      })
    }
  },

  async mounted() {
    if (shouldUseCaptcha()) {
      await maybeLoadReCaptchaScript();
    }
  }
}
</script>
